import { SearchInput } from '@mm/components';
import {
  MyLeadsFilterTypes,
  SubsectionKeys,
} from '@mm/state/interfaces/myLeads';
import { allTags } from '@mm/state/selectors/tags';
import { Divider, Pagination } from 'antd';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './TagsFilter.module.css';

type Props = {
  isExcluded?: boolean;
  css?: {
    container?: string;
    title?: string;
  };
  renderCheckbox: (name: string, label: string, ...args) => void;
};

export const TagsFilter = ({ isExcluded, css, renderCheckbox }: Props) => {
  const tags = useSelector(allTags);
  const [filteredTags, setFilteredTags] = useState(tags);
  const [searchValue, setSearchValue] = useState('');
  const [pagination, setPagination] = useState({ page: 1, pageSize: 10 });
  const title = isExcluded ? 'Exclude tags' : 'Include tags';

  const onSearchTags = (search: string) => {
    setFilteredTags(
      tags.filter(tag =>
        tag.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
      ),
    );
  };

  const onPaginationChange = (page: number, pageSize: number) => {
    setPagination({ page, pageSize });
  };

  const indexStart = (pagination.page - 1) * pagination.pageSize;
  const indexEnd = pagination.page * pagination.pageSize;

  return (
    <div className={classNames(styles.container, css?.container)}>
      <div className={classNames(styles.title, css?.title)}>{title}</div>
      <SearchInput
        css={{ container: styles.searchInput }}
        placeholder="Search Tags"
        value={searchValue}
        onChange={event => {
          setSearchValue(event.target.value);
          onSearchTags(event.target.value);
        }}
        maxLength={100}
      />
      <div>
        {filteredTags.map(
          (tag, index) =>
            index >= indexStart &&
            index < indexEnd &&
            renderCheckbox(SubsectionKeys.tags, tag.name, {
              type: isExcluded
                ? MyLeadsFilterTypes.excludedAttributes
                : MyLeadsFilterTypes.attributes,
              showOnlyWhenExists: false,
              isList: true,
            }),
        )}
      </div>
      <Divider className={styles.divider} />
      <Pagination
        className={styles.pagination}
        simple
        hideOnSinglePage
        defaultCurrent={1}
        total={filteredTags.length}
        onChange={onPaginationChange}
      />
    </div>
  );
};
